import { render, staticRenderFns } from "./ClientesHolder.vue?vue&type=template&id=79c95797&scoped=true"
import script from "./ClientesHolder.vue?vue&type=script&lang=js"
export * from "./ClientesHolder.vue?vue&type=script&lang=js"
import style0 from "./ClientesHolder.vue?vue&type=style&index=0&id=79c95797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c95797",
  null
  
)

export default component.exports